import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import AssignableForms from "./components/AssignableForms";
import FormAssignment from "./components/FormAssignment";
import Skeleton from "./QuestionsAssignment.skeleton";
import Toolbar from "./components/Toolbar";

import { Card, CardContent } from "@components/base";
import { PageTitle } from "@components/common";
import { useGetFormAssignmentConfig } from "@api";
import { useUserStore } from "@store/user";

const QuestionsAssignment: FC = () => {
  const { formId } = useParams<{ formId: string }>();
  const { t } = useTranslation();
  const { user } = useUserStore();

  const { isLoadingGetFormAssignmentConfig } = useGetFormAssignmentConfig(user, {
    formId,
  });

  const content = isLoadingGetFormAssignmentConfig ? (
    <Skeleton />
  ) : formId ? (
    <FormAssignment />
  ) : (
    <AssignableForms />
  );

  return (
    <Card>
      <CardContent>
        <PageTitle title={t("questionsAssignment.title")} />
        <Toolbar />
        {content}
      </CardContent>
    </Card>
  );
};

export default QuestionsAssignment;
